<template>
  <div class="verify-email">

    <v-container class="pa-3 pt-5">
      <template v-if="loading">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </template>
      <div v-else>
        <p class="my-3 text-body-2">メールアドレスの認証が完了しました。</p>
        <p class="my-3 text-body-2">トップに戻ってログインしてください。</p>
        <v-btn @click="gotoTopClick">
          トップに戻る
        </v-btn>
      </div>
    </v-container>

  </div>
</template>

<script>
import { Put } from '../assets/request-api.js'

export default {
  data: () => ({
    loading: true,
    tm: null,
  }),
  computed:{
  },
  methods:{
    gotoTopClick() {
      if (this.tm) {
        clearInterval(this.tm)
      }
      this.$store.dispatch('error/clearError')
      window.location = '/'
    },
  },
  async created(){
    const url = '/verify/email'
    const params = {
      remember_token: this.$route.params.token
    }
    const result = await Put(url, params)

    if(RegExp(/^2[0-9]{2}$/u).test(result.statusCode)) {
      this.tm = setTimeout(() => {
        this.$store.dispatch('error/clearError')
        window.location = '/'
      }, 10000);
    } 
    else {
      this.$store.dispatch('error/setError', { code: result.statusCode, id: result.requestId, message: result.response }, { root: true })
    }
    this.loading = false
  },
}
</script>